import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'productSeriesController';
export default {
    /**
     * 获取所有的产品名称
     */
    getAllProductSeries: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllProductSeries',
        type: requestType.Get
    }
};
